import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "new26",
  "use": "new26-usage",
  "viewBox": "0 0 12.2 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.2 11\" id=\"new26\"><title>资源 1</title><g data-name=\"图层 2\"><path d=\"M4.7 0c.2 0 .3.1.4.3l.3 1.2a.66.66 0 0 0 .5.4h4.9a1.42 1.42 0 0 1 1.4 1.3v6.5a1.42 1.42 0 0 1-1.4 1.3H1.2A1.24 1.24 0 0 1 0 9.7V1.3A1.24 1.24 0 0 1 1.2 0zm6 8a.35.35 0 0 0-.2.1v.8c0 .4-.2.4-.4.4h-2a.22.22 0 0 0-.2.2.35.35 0 0 0 .1.2h2.1a.71.71 0 0 0 .8-.7v-.8a.22.22 0 0 0-.2-.2zm-.2-.8l-.1.1a.1.1 0 0 0 .1.1c0 .1 0 .1.1.1a.1.1 0 0 0 .1-.1l.1-.1a.1.1 0 0 0-.1-.1c0-.1-.2-.1-.2 0zm.6-6.9a.43.43 0 0 1 .4.4.43.43 0 0 1-.4.4H6.4A.43.43 0 0 1 6 .7a.43.43 0 0 1 .4-.4z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/new26.svg
// module id = EnjH
// module chunks = 6